<template>

<div class="card">
  
 <!-- Card content -->
  <div class="card-body">

    <!-- Title -->
    <div class="row">
      <div class="col-md-11">
      <h6 class="card-title">
        <a>{{ pergunta.ordemExibicao}} ) {{ pergunta.titulo }}</a>
        <span v-if="pergunta.obrigatoria" style="color:red;font-weigth:bold">*</span>
      </h6>
      </div>
      <div class="col">
        <!-- <span class="badge badge-success" style="float:rigth"><i class="bi bi-check"></i></span> -->
      </div>
    </div>
    <!-- Text -->
    <p class="card-text" v-if="pergunta.descricao" v-html="pergunta.descricao"></p>
    
<div class="form-group">
    <label for="selectbox_`${pergunta.perguntaId}`"></label>
    <v-select 
        class="opcoes-resposta"
        placeholder="Selecione uma ou mais opções"
        v-model="opcaoResposta"  
        :multiple="true"
        :closeOnSelect="false"        
        label="valor"
        code="opcaoResposta.opcaoRespostaId"
        @option:selecting="responderPergunta"
        @option:deselecting="removerResposta"    
        @option:deselected="desfazerSelecaoOpcao"         
        :options="opcoesRespostas">
            <template #no-options="{search}">Nenhuma opção para o termo buscado: "{{search}}"</template>
        </v-select>
      </div>
    </div>
   
  </div>


</template>

<script>
import Vue from 'vue'
import vSelect from 'vue-select'
import repostaPerguntaMethodsMixin from './ResponderPerguntaMixin'
Vue.component('v-select', vSelect);
import '../../../node_modules/vue-select/dist/vue-select.css';


export default {
  mixins: [repostaPerguntaMethodsMixin],
  name: 'comp-pergunta-select2',
  props: ['pergunta', 'permitirResponder'],
  data () {
    return {
      resposta: '',
      opcaoResposta:{},
      opcoesRespostas:[],
    }
  },
  computed: {
    nomeOpcaoResposta(){
      return `opcaoResposta_pergunta_${this.pergunta.perguntaId}`
    },
    
    botaoDesabilitado () {
      return this.resposta === '' || !this.permitirResponder
    }
  },
  methods: {  
      desfazerSelecaoOpcao(deselectedOption){
          if(this.isDebug)
            console.log("deselectedOption",deselectedOption)
      },
      ordenarOpcoesResposta(opcaoA,opcaoB){
          return  opcaoA.ordemExibicao - opcaoB.ordemExibicao;
      },
      removerResposta(opcaoResposta){        
        const opcoes = this.opcoesRespostas || [];
        opcoes.push(opcaoResposta);
        this.opcoesRespostas = opcoes.sort(this.ordenarOpcoesResposta);
        this.removerRespostaMixin(opcaoResposta);
      },
    obterId(opcaoResposta){
      return `opcao_resposta_pergunta_${opcaoResposta.opcaoRespostaPerguntaId}`
    },
    responderPergunta (opcaoResposta) {

        const pergunta = this.pergunta;
        const {
          perguntaId, 
          opcaoRespostaId,
          perguntaEncadeadaId, 
          tipoEncadeamentoPergunta,
          encadeamentoPerguntaId,
          sessaoFormularioPerguntaId,
          sessaoFormularioId,
          valor
        } = opcaoResposta;

      //this.removerTodasRespostasPergunta(sessaoFormularioPerguntaId);
      this.responderPerguntaMixin({pergunta, opcaoResposta});

       // remover o selecionado
    
      const novaOpcoesRespostas =  this.opcoesRespostas.filter(op=>op.opcaoRespostaId != opcaoResposta.opcaoRespostaId); 
      if(this.isDebug)
        console.log('opcaoRespostaId', opcaoRespostaId)
      
      this.opcoesRespostas = novaOpcoesRespostas.sort(this.ordenarOpcoesResposta);
  

      //verificar se existe pergunta encadeada a resposta
      //if(perguntaEncadeadaId && Number(perguntaEncadeadaId) > 0)   
      const configPerguntaEncadeada = 
        {
          perguntaId,
          perguntaEncadeadaId,
          tipoEncadeamentoPergunta,
          encadeamentoPerguntaId, 
          valor,
          sessaoFormularioPerguntaId,
          sessaoFormularioId
       }   
      
      this.verificarPerguntaEncadeada(configPerguntaEncadeada);
    }
  },
  mounted () {      
    this.opcoesRespostas = this.pergunta
                               .opcoesResposta             
                               .sort(this.ordenarOpcoesResposta);
 
  }
}
</script>

<style>
  .opcoes-resposta{
    font-size: 12pt;
  }

</style>



// WEBPACK FOOTER //
// src/components/PerguntasComponent/PerguntaTipoSelect2.vue